import {useEffect, useState} from 'react'
import Breadcrumbs from '../../../sharedComponent/Breadcrumbs/Breadcrumbs'
import SearchList from '../../../sharedComponent/SearchList/SearchList'
import {OUTBOUNDLISTCONFIGS} from './OutboundLiveAgentUtils'
import {useNavigate, useParams} from 'react-router-dom'
import {useLazyQuery} from '@apollo/client'
import {
  CHECK_OUTBOUND_CUSTOMER_STATUS,
  GET_OUTBOUND_CUSTOMER_LIST,
} from '../../../../utils/GraphQLAPI'
import {GLOBAL_CONSTANTS} from '../../../../utils/GlobalConstants'

import {alert} from '../../../../utils/helper'
const OutboundLiveAgentCallList = () => {
  const [filterOptions, setFilterOptions] = useState({
    perPage: 10,
    orderBy: 'DESC',
    page: 1,
  })
  const [customerList, setCustomerList] = useState([])

  const getUrlParams = useParams()
  const navigate = useNavigate()
  //queries
  const [getOutboundList, {loading, data: outboundCustomerList}] = useLazyQuery(
    GET_OUTBOUND_CUSTOMER_LIST,
    {
      fetchPolicy: GLOBAL_CONSTANTS.networkOnly,
      onCompleted: (data) => {
        console.log('ds', data)
        setCustomerList(
          data?.getOutBoundAgentCustomers?.customerList?.map((list: any) => ({
            ...list,
            image: 'Sidebar-Menuphone.svg',
          }))
        )
      },
      variables: filterOptions,
    }
  )
  const [checkCustomerStatus] = useLazyQuery(CHECK_OUTBOUND_CUSTOMER_STATUS)
  //handlers
  const onListRowClick = (values: any) => {
    console.log(values)
    checkCustomerStatus({
      variables: {
        tpvId: values.tpvId,
      },
    }).then((res: any) => {
      if (res.data.liveAgentPickCustomer) {
        navigate(`/${getUrlParams.adminUser}/outbound-liveagent-call`, {
          state: {
            tpvId: values.tpvId,
            pincode: values.pincode,
            failScript: values.outBoundMessage,
            customerName: values.customerName,
            dialInNumber: values.DailInNumber,
            clientName: values.clientName,
          },
        })
      } else {
        alert('Customer already in call', 'info')
        setTimeout(
          () =>
            getOutboundList({
              variables: filterOptions,
            }),
          2000
        )
      }
    })
  }
  const [outboundList, setOutboundList] = useState()

  useEffect(() => {
    getOutboundList({
      variables: filterOptions,
    })
  }, [])
  console.log('outboudncusromerlist', customerList, outboundCustomerList)

  return (
    <>
      <Breadcrumbs title='Outbound Live Agent Call' subTitle='Home - Outbound Live Agent Call' />

      <SearchList
        filterOptions={filterOptions}
        setFilterOptions={setFilterOptions}
        listLoading={loading}
        paginatedCount={customerList.length}
        listCount={outboundCustomerList?.getOutBoundAgentCustomers?.totalCount}
        isSearchable={false}
        idFieldName='tpvId'
        apiData={customerList}
        listConfigs={OUTBOUNDLISTCONFIGS}
        onRowClick={onListRowClick}
        isActiveApiFieldName=''
      />
    </>
  )
}
export default OutboundLiveAgentCallList
